import React from 'react';
import { Button, Progress } from 'semantic-ui-react';

const FloatingExportButton = ({ isProgressValue, onClick }) => {
    return (
        <div style={{
            position: 'fixed',
      bottom: 32,
      right: 72,
      zIndex: 9999,
      pointerEvents: 'auto',
      background: 'none'
        }}>
            {isProgressValue > 0 && (
                <Progress 
                    percent={isProgressValue} 
                    size='small' 
                    style={{ 
                        marginBottom: '10px',
                        width: '200px'
                    }}
                />
            )}
            <Button
                primary
                circular
                icon='download'
                size='large'
                onClick={onClick}
                style={{
                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                }}
            />
        </div>
    );
};

export default FloatingExportButton;